import React, { useState } from 'react';
import { Popover, PopoverContent, PopoverTrigger } from '../ui/popover';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { ListFilter } from 'lucide-react';

/**
 * Header filter for a date column — filters rows to a from/to date range.
 * `range` = { from: 'YYYY-MM-DD'|'', to: 'YYYY-MM-DD'|'' }
 */
export const DateRangeFilterPopover = ({ label = 'Date', range, onChange, testId }) => {
  const [open, setOpen] = useState(false);
  const [draft, setDraft] = useState(range);

  const handleOpenChange = (next) => {
    if (next) setDraft(range);
    setOpen(next);
  };

  const isActive = !!(range.from || range.to);

  return (
    <Popover open={open} onOpenChange={handleOpenChange}>
      <PopoverTrigger asChild>
        <button
          type="button"
          className={`inline-flex items-center gap-1 hover:text-foreground transition-colors ${isActive ? 'text-primary font-semibold' : ''}`}
          data-testid={testId || `col-filter-${label}`}
        >
          {label}
          <ListFilter className={`w-3 h-3 ${isActive ? 'fill-primary/20' : ''}`} />
        </button>
      </PopoverTrigger>
      <PopoverContent className="w-64 p-3" align="start">
        <div className="space-y-2.5">
          <div className="space-y-1">
            <Label className="text-xs">From</Label>
            <Input
              type="date"
              value={draft.from || ''}
              onChange={(e) => setDraft(d => ({ ...d, from: e.target.value }))}
              className="h-8 text-sm"
              data-testid={`col-filter-date-from-${label}`}
            />
          </div>
          <div className="space-y-1">
            <Label className="text-xs">To</Label>
            <Input
              type="date"
              value={draft.to || ''}
              onChange={(e) => setDraft(d => ({ ...d, to: e.target.value }))}
              className="h-8 text-sm"
              data-testid={`col-filter-date-to-${label}`}
            />
          </div>
        </div>
        <div className="flex justify-end gap-2 mt-3 pt-2 border-t">
          <Button size="sm" variant="ghost" onClick={() => { setDraft({ from: '', to: '' }); onChange({ from: '', to: '' }); setOpen(false); }}>
            Clear
          </Button>
          <Button
            size="sm"
            className="bg-lime text-lime-foreground hover:bg-lime/90"
            onClick={() => { onChange(draft); setOpen(false); }}
            data-testid={`col-filter-date-apply-${label}`}
          >
            Apply
          </Button>
        </div>
      </PopoverContent>
    </Popover>
  );
};

export default DateRangeFilterPopover;
